@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  <div class="flex align-items-center">
    <div class="w-4rem">
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'due' ||
          $.row[$.adata.fetch_key].toLowerCase() === '')
      ) {
        <p-tag
          class="text-xxs text-white uppercase font-normal"
          severity="warn"
          >{{ $.row.inv_status }}
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'overdue' ||
          $.row[$.adata.fetch_key].toLowerCase() === '')
      ) {
        <p-tag
          severity="danger"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >{{ $.row.status }}
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'paid' ||
          $.row[$.adata.fetch_key].toLowerCase() === '')
      ) {
        <p-tag
          severity="success"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Paid
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'open' ||
          $.row[$.adata.fetch_key].toLowerCase() === '1')
      ) {
        <p-tag
          severity="danger"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Open
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'closed' ||
          $.row[$.adata.fetch_key].toLowerCase() === '3')
      ) {
        <p-tag
          severity="success"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Closed
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'void' ||
          $.row[$.adata.fetch_key].toLowerCase() === '0')
      ) {
        <p-tag
          severity="warn"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Void
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'partialopen' ||
          $.row[$.adata.fetch_key].toLowerCase() === '2')
      ) {
        <p-tag
          severity="danger"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Partial Open
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'refunded' ||
          $.row[$.adata.fetch_key].toLowerCase() === '7')
      ) {
        <p-tag
          severity="warn"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Refunded
        </p-tag>
      }
      @if (
        $.row &&
        $.adata.fetch_key &&
        ($.row[$.adata.fetch_key].toLowerCase() === 'notpaid' ||
          $.row[$.adata.fetch_key].toLowerCase() === '4')
      ) {
        <p-tag
          severity="danger"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Not Paid
        </p-tag>
      }
      @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'completed')) {
        <p-tag
          severity="info"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Completed
        </p-tag>
      }
      @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key].toLowerCase() === 'pending')) {
        <p-tag
          severity="warn"
          class="text-xxs font-normal uppercase white-space-nowrap"
          >Pending
        </p-tag>
      }
    </div>
  </div>
}
